import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { convertTitleText, getEmptyLogoUrl } from "../../component/common/BaseUtil";
import '../../App.css';
import { TALENT_IMAGE_URL_PREFIX } from "../../Config";

export function TalentCard(props) {
    const navigate = useNavigate();

    // 재능 엔티티 필드에 맞게 변수 할당
    const { object, index, cityList, returnTo } = props;

    // 1. 메인 이미지 URL 찾기 로직
    let mainImageUrl = "";
    if (object.serviceImage) {
        const mainImgObj = object.serviceImage;
        if (mainImgObj) {
            // 상세페이지 경로 규칙 적용: directory/fileNameFormat
            mainImageUrl = TALENT_IMAGE_URL_PREFIX + `${mainImgObj.fileDirectory}/${mainImgObj.uniqFileName}`;
        }
    }

    const fallbackImage = getEmptyLogoUrl("empty_talent", "png");

    useEffect(() => {
        console.log(object.serviceImage)
    }, []);

    const getCityText = () => {
        // cityList에서 현재 object의 selectedCityId와 일치하는 도시명 찾기
        const city = cityList.find(c => c.id === object.selectedCityId);

        if (object.isRemote === 1) {
            return city ? `${city.cityName} 대면 | 온라인 가능` : "온라인";
        }

        return city ? city.cityName : "지역무관";
    };

    function onClick() {
        // 상세 페이지로 이동 (registrationId 사용)
        let regId = object.registrationId;
        let url = `/talent_service/${regId}`;
        navigate(url);
    }

    // 가격 정보 포맷팅
    const units = { HOUR: '시간당', ONCE: '회당', DAY: '일당' };
    const unitLabel = units[object.priceUnit] || object.priceUnit;
    const priceDisplay = Number(object.isPriceNegotiable) === 1
        ? `가격협의 / ${unitLabel}`
        : object.priceValue
        ? `${object.priceValue.toLocaleString()}유로 / ${unitLabel}`
        : "가격 협의";

    return (
        <div className="card h-100" key={index}
            onClick={onClick}
            style={{
                // 1. 최소 높이를 대폭 줄여 내용물에 맞게 카드가 형성되도록 함
                minHeight: '250px',
                marginTop: '10px',
                marginBottom: '10px',
                border: '1px solid #eee',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'pointer'
            }}>
            <div className="card-body d-flex flex-column" style={{ padding: '10px 10px 8px 10px' }}>
                {/* 1. 서비스 대표 이미지 (serviceImages가 있다면 첫 번째 이미지 노출) */}
                <div className="d-flex justify-content-center align-items-start mb-2">
                    <div style={{
                        width: '100%',
                        // 1. 고정 height 대신 min-height와 max-height 사용
                        aspectRatio: '4 / 3',
                        overflow: 'hidden',
                        borderRadius: '10px',
                        backgroundColor: '#fff',
                        display: 'flex',
                        alignItems: 'flex-start', // 상단 밀착
                        justifyContent: 'center',
                        position: 'relative'
                    }}>
                        <img
                            src={mainImageUrl || fallbackImage}
                            alt="Service"
                            className="talent-main-img" // 클래스 부여
                            style={{
                                // 2. 핵심: 너비를 100%로 채우고 높이는 비율에 맞게 자동 조절
                                width: '100%',
                                height: '100%',
                                // 이미지 전체를 보여주되, 비율에 맞게 박스 안에 안착
                                objectFit: 'contain',
                                objectPosition: 'top', // 위쪽 기준 정렬
                                transition: 'transform 0.3s ease-in-out',
                            }}
                            onError={(e) => { e.target.src = fallbackImage; }}
                        />
                    </div>
                </div>

                {/* 2. 카테고리 표시 */}
                <h6 style={{
                    fontFamily: 'Nanum Gothic',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#333',     // 블루 대신 짙은 그레이/블랙 적용
                    marginBottom: '4px',
                    marginTop: '2px'
                }}>
                    {object.categoryName}
                </h6>

                {/* 3. 서비스 타이틀 */}
                <h4 className="card-title text-truncate-2"
                    style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '18px', height: '48px', overflow: 'hidden' }}>
                    {convertTitleText(object.title)}
                </h4>

                {/* 4. 지역 및 가격 정보 */}
                <div style={{ width: '100%', marginTop: '4px' }}>
                    <p className="card-text text-muted" style={{ fontSize: '14px', marginBottom: '2px' }}>
                        📍 {getCityText()}
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                        <span style={{ fontWeight: 'bold', color: '#333' }}>{priceDisplay}</span>
                        {/* <button className="btn btn-sm btn-primary" onClick={onClick} type="button">상세보기</button> */}
                    </div>
                </div>
            </div>
        </div>
    );
}